import { JobApplicationSource, JobApplicationFooBar } from '@borg/types';

class JobApplicationRepository extends Repository<JobApplicationFooBar> {
  get(jobId: string, source?: JobApplicationSource) {
    return this._get({ url: `/jobs/${jobId}/applications/me`, query: { source } });
  }
  save(application: JobApplicationFooBar) {
    return this._save({ url: `/applications/${application.id}`, data: application.data });
  }
}

export const jobApplicationRepository = new JobApplicationRepository();
